'use client';

import { Pagination as MuiPagination, Stack, useMediaQuery, useTheme } from '@mui/material';
import { PaginationItem } from '@mui/material';

import { MetaSchemaType } from '@/global/schemas/api.schema';

interface PaginationProps {
  meta: MetaSchemaType;
  onPageChange: (page: number) => void;
}

export const Pagination = ({ meta, onPageChange }: PaginationProps) => {
  const { page: currentPage, last: totalPages } = meta;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      sx={{
        width: '100%',
        padding: { xs: '16px 0', md: '20px 0' },
        overflow: 'hidden',
      }}>
      <MuiPagination
        count={totalPages}
        page={currentPage}
        onChange={(_, page) => onPageChange(page)}
        color='primary'
        siblingCount={isMobile ? 0 : isTablet ? 1 : 2}
        boundaryCount={1}
        size={isMobile ? 'small' : isTablet ? 'medium' : 'large'}
        renderItem={item => (
          <PaginationItem
            {...item}
            sx={{
              color: 'white',
              fontSize: { xs: '14px', sm: '16px', md: '18px' },
              fontWeight: item.selected ? 600 : 400,
              minWidth: { xs: '32px', sm: '36px', md: '40px' },
              height: { xs: '32px', sm: '36px', md: '40px' },
              borderRadius: '100px',
              '&.Mui-selected': {
                backgroundColor: '#890096',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#890096',
                },
              },
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
              '&.Mui-disabled': {
                opacity: 0.3,
              },
            }}
          />
        )}
        sx={{
          '& .MuiPagination-ul': {
            gap: { xs: '4px', sm: '6px', md: '8px' },
            flexWrap: 'wrap',
            justifyContent: 'center',
          },
          '& .MuiPaginationItem-root': {
            color: 'white',
            '&.Mui-selected': {
              backgroundColor: '#890096',
              color: 'white',
            },
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          },
        }}
      />
    </Stack>
  );
};
